import {lazy, Suspense} from 'react'

import {Loading, RichText} from '@sdox/ui'

import {useTipTapEditorContext} from './EditorContext'

import type {Editor} from '@tiptap/react'

const HtmlDebugger = lazy(() => import('./HtmlDebugger'))

interface EditorDebugProps {
  editor: Editor
}

export const EditorDebug = (props: EditorDebugProps) => {
  const {editor} = props
  const {showDebugger} = useTipTapEditorContext()

  if (!showDebugger) {
    return null
  }

  return (
    <div className={'mt-spacing-6 flex flex-col gap-spacing-12'}>
      <div className={'flex flex-col'}>
        <span className={'self-start rounded-radius-md border-1 border-blue-700 bg-blue-300 px-2 py-1'}>
          Richtext rendering
        </span>
        <RichText
          className={'border-1 border-dashed border-gray-600'}
          content={editor.getHTML()}
        />
      </div>
      <div className={'flex flex-col'}>
        <span className={'self-start rounded-radius-md border-1 border-blue-700 bg-blue-300 px-2 py-1'}>
          Html output
        </span>
        <Suspense fallback={<Loading/>}>
          <HtmlDebugger html={editor.getHTML()}/>
        </Suspense>
      </div>
    </div>
  )
}
